var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.orderedExtras, function(extra) {
        return _c("div", { key: extra.id, staticClass: "entry" }, [
          _c(
            "label",
            {
              class:
                _vm.hasAndOperator(_vm.node) && !_vm.hasSubTrees(_vm.node)
                  ? "disabled"
                  : "",
              attrs: { for: "modal-" + extra.id }
            },
            [
              _vm._v(
                _vm._s(extra.label) + " (" + _vm._s(extra.option_code) + ")"
              )
            ]
          ),
          _vm.hasAndOperator(_vm.node) && !_vm.hasSubTrees(_vm.node)
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: extra.selected,
                    expression: "extra.selected"
                  },
                  {
                    name: "default",
                    rawName: "v-default",
                    value: extra,
                    expression: "extra"
                  }
                ],
                attrs: {
                  id: "modal-" + extra.id,
                  type: "checkbox",
                  disabled: "true"
                },
                domProps: {
                  checked: Array.isArray(extra.selected)
                    ? _vm._i(extra.selected, null) > -1
                    : extra.selected
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = extra.selected,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(extra, "selected", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              extra,
                              "selected",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(extra, "selected", $$c)
                      }
                    },
                    _vm.checkRequirements
                  ]
                }
              })
            : _vm._e(),
          _vm.hasOrOperator(_vm.node) && !_vm.hasSubTrees(_vm.node)
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedExtraId[_vm.currentLevel].id,
                    expression: "selectedExtraId[currentLevel].id"
                  }
                ],
                attrs: {
                  id: "modal-" + extra.id,
                  type: "radio",
                  name: _vm.level,
                  disabled: _vm.levelDisabled
                },
                domProps: {
                  value: extra.id,
                  checked: _vm._q(
                    _vm.selectedExtraId[_vm.currentLevel].id,
                    extra.id
                  )
                },
                on: {
                  change: [
                    function($event) {
                      return _vm.$set(
                        _vm.selectedExtraId[_vm.currentLevel],
                        "id",
                        extra.id
                      )
                    },
                    function($event) {
                      return _vm.selectedExtraChanged(_vm.node)
                    }
                  ]
                }
              })
            : _vm._e(),
          _c("span", { staticClass: "price" }, [
            extra.hidden_costs != null
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm._f("formatCurrency")(extra.hidden_costs.gross))
                  )
                ])
              : _vm._e(),
            extra.hidden_costs == null
              ? _c("span", [
                  _vm._v(_vm._s(_vm._f("formatCurrency")(extra.price_gross)))
                ])
              : _vm._e()
          ])
        ])
      }),
      _vm.hasSubTrees(_vm.node)
        ? _c(
            "div",
            _vm._l(_vm.node, function(value, key, index) {
              return _c(
                "div",
                { key: index },
                [
                  _vm._l(value.extras, function(extra) {
                    return _vm.hasSubTrees(_vm.node) &&
                      _vm.hasExtras(value) &&
                      !_vm.hasOperator(value)
                      ? _c("div", { key: extra.id, staticClass: "entry" }, [
                          _vm.hasSubTrees(_vm.node) &&
                          _vm.hasExtras(value) &&
                          _vm.hasOperator(_vm.node)
                            ? _c(
                                "label",
                                {
                                  class:
                                    _vm.hasSubTrees(_vm.node) &&
                                    _vm.hasExtras(value) &&
                                    _vm.hasAndOperator(_vm.node)
                                      ? "disabled"
                                      : "",
                                  attrs: { for: "modal-" + extra.id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(extra.label) +
                                      " (" +
                                      _vm._s(extra.option_code) +
                                      ")"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.hasSubTrees(_vm.node) &&
                          _vm.hasExtras(value) &&
                          _vm.hasAndOperator(_vm.node)
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: extra.selected,
                                    expression: "extra.selected"
                                  },
                                  {
                                    name: "default",
                                    rawName: "v-default",
                                    value: extra,
                                    expression: "extra"
                                  }
                                ],
                                attrs: {
                                  id: "modal-" + extra.id,
                                  type: "checkbox",
                                  disabled: "true"
                                },
                                domProps: {
                                  checked: Array.isArray(extra.selected)
                                    ? _vm._i(extra.selected, null) > -1
                                    : extra.selected
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = extra.selected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              extra,
                                              "selected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              extra,
                                              "selected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(extra, "selected", $$c)
                                      }
                                    },
                                    _vm.checkRequirements
                                  ]
                                }
                              })
                            : _vm._e(),
                          _vm.hasSubTrees(_vm.node) &&
                          _vm.hasExtras(value) &&
                          _vm.hasOrOperator(_vm.node)
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedExtraId[_vm.level].id,
                                    expression: "selectedExtraId[level].id"
                                  }
                                ],
                                attrs: {
                                  id: "modal-" + extra.id,
                                  type: "radio",
                                  name: _vm.levelClass,
                                  disabled: _vm.levelDisabled
                                },
                                domProps: {
                                  value: extra.id,
                                  checked: _vm._q(
                                    _vm.selectedExtraId[_vm.level].id,
                                    extra.id
                                  )
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(
                                        _vm.selectedExtraId[_vm.level],
                                        "id",
                                        extra.id
                                      )
                                    },
                                    function($event) {
                                      return _vm.selectedExtraChanged(_vm.node)
                                    }
                                  ]
                                }
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "price" }, [
                            extra.hidden_costs != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        extra.hidden_costs.gross
                                      )
                                    )
                                  )
                                ])
                              : _vm._e(),
                            extra.hidden_costs == null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        extra.price_gross
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  }),
                  _vm.hasSubTrees(_vm.node) && _vm.hasOperator(value)
                    ? _c("div", { staticClass: "entry" }, [
                        _vm.hasSubTrees(_vm.node) &&
                        _vm.hasAndOperator(_vm.node)
                          ? _c("input", {
                              attrs: {
                                disabled: "true",
                                type: "checkbox",
                                checked: ""
                              }
                            })
                          : _vm._e(),
                        _vm.hasSubTrees(_vm.node) && _vm.hasOrOperator(_vm.node)
                          ? _c("input", {
                              attrs: { type: "radio", name: this.currentLevel }
                            })
                          : _vm._e(),
                        _vm.hasSubTrees(_vm.node) && _vm.hasOperator(_vm.node)
                          ? _c(
                              "div",
                              [
                                _vm.hasSubTrees(_vm.node) &&
                                _vm.hasOperator(_vm.node)
                                  ? _c("RequirementsTree", {
                                      attrs: {
                                        level: _vm.currentLevel + 1,
                                        node: value,
                                        checkRequirements: _vm.checkRequirements
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }